const clerkDomain = process.env.NEXT_PUBLIC_CLERK_DOMAIN || 'clerk.com';

export const URLS = {
  // Internal
  home: '/',
  blog: '/blog',
  examples: '/guides',
  pricing: '/pricing',
  company: '/company',
  customers: '/customers',
  support: '/support',
  terms: '/terms',
  privacy: '/privacy',
  dpa: '/data-processing-agreement',
  startups: '/startups',
  tutorials: '/tutorials',
  nextAuth: '/solutions/nextjs-authentication',
  emailMagicLinks: '/features/email-magic-links',
  socialSSO: '/features/social-sso',
  passwords: '/features/passwords',
  orgManagement: '/features/organization-management',
  securityPage: '/features/security',
  web3Page: '/features/web3',
  sessionMgmt: '/features/session-management',
  multifactorAuth: '/features/multifactor-authentication',
  authAtTheEdge: 'https://edge.clerk.app/',
  passwordlessAuthentication: '/passwordless-authentication',
  nextjsAuthentication: '/nextjs-authentication',
  componentSignUp: '/components/sign-up',
  componentSignIn: '/components/sign-in',
  componentUserButton: '/components/user-button',
  componentUserProfile: '/components/user-profile',
  hasuraIntegration: '/integrations/hasura',
  supabaseIntegration: '/integrations/supabase',
  firebaseIntegration: '/integrations/firebase',
  grafbaseIntegration: '/integrations/grafbase',
  fauna: '/integrations/fauna',
  passcodes: '/features/email-sms-passcodes-otp',
  reactNative: '/solutions/react-native-expo',
  gatsby: '/solutions/gatsby',
  react: '/solutions/react-authentication',
  node: '/solutions/node',
  redwood: '/solutions/redwood',
  ruby: '/solutions/ruby',
  remix: '/solutions/remix-authentication',
  components: '/components',
  authUserComponents: '/components#auth-user-components',
  b2bComponents: '/components#b2b-components',
  customizeComponents: '/components#customization',

  // External
  apiStatus: `https://status.${clerkDomain}`,
  changelog: `https://updates.${clerkDomain}`, // deprecated
  careers: 'https://apply.workable.com/clerk-dev',
  dashboard: `https://dashboard.${clerkDomain}`,
  dashboardApiKeys: `https://dashboard.${clerkDomain}/last-active?path=api-keys`,
  mediaKit:
    'https://drive.google.com/drive/folders/14FZPSKnI-AHadk8jn-TgaHPRqOyq0E10?usp=sharing',
  nistGov: 'https://pages.nist.gov/800-63-3/sp800-63b.html',
  clerkSDKNode:
    'https://github.com/clerkinc/javascript/tree/main/packages/sdk-node',
  gatsbyPlugin: 'https://www.gatsbyjs.com/plugins/gatsby-plugin-clerk/',
  roadmap:
    'https://clerkdev.notion.site/019192f70e864d40a44870102cf2176f?v=c594d282a5f544b39aa0612842e9fd6b',
  demoVideo: 'https://www.youtube-nocookie.com/embed/xazOE62k6AY',

  // Docs
  docs: '/docs',
  quickstarts: '/docs/quickstarts/overview',
  quickstartsReact: '/docs/quickstarts/get-started-with-create-react-app',
  quickstartsNext: '/docs/nextjs/get-started-with-nextjs',
  quickstartsRemix: '/docs/quickstarts/get-started-with-remix',
  quickstartsRedwood: '/docs/quickstarts/get-started-with-redwoodjs',
  quickstartsGatsby: '/docs/quickstarts/get-started-with-gatsby',
  quickstartsExpo: '/docs/quickstarts/get-started-with-expo',
  gatsbyDocs: '/docs/get-started/gatsby',
  web3: '/docs/get-started/web3',
  nextjsDocs: '/docs/nextjs/get-started-with-nextjs',
  remixDocs: '/docs/get-started/remix',
  faunaDocs: '/docs/integration/fauna',
  firebase: '/docs/integration/firebase',
  hasura: '/docs/integration/hasura',
  grafbase: '/docs/integration/grafbase',
  redwoodDocs: '/docs/get-started/redwoodjs',
  supabaseDocs: '/docs/integration/supabase',
  JWTTemplates: '/docs/how-to/jwt-templates',
  security: `/docs/security/introduction`,
  jsDocs: '/docs/reference/clerkjs/installation',
  quickstartExpo: '/docs/quickstarts/get-started-with-expo',
  frontendApiReference: `https://reference.clerk.dev/reference/frontend-api-reference`,
  backendApiReference: '/docs/reference/backend-api',
  nodeDocs: '/docs/reference/node/getting-started',
  rubyDocs: '/docs/reference/ruby/getting-started',
  goDocs: 'docs/reference/golang/getting-started',
  expoDocs: '/quickstarts/get-started-with-expo',
  metamask: '/docs/component-reference/signin-with-metamask-button',
  javascript: '/docs/reference/clerkjs/installation',
  magicLinksDocs: '/docs/authentication/custom-flows/magic-links',
  socialSSODocs: '/docs/authentication/social-connections-oauth',
  passwordsDocs: '/docs/authentication/custom-flows/password',
  web3Docs: '/docs/users/web3-wallets',
  multifactorAuthDocs: '/docs/authentication/custom-flows/multifactor',
  passcodesDocs: '/docs/authentication/custom-flows/email-sms-otp',

  // Starters
  nextjsStarter: 'https://github.com/clerkinc/clerk-nextjs-starter',
  remixStarter: 'https://github.com/clerkinc/remix-auth-starter',
  supabaseStarter: 'https://github.com/clerkinc/clerk-supabase-starter',
  redwoodStarter: 'https://github.com/clerkinc/clerk-redwood-starter',
  gatsbyStarter: 'https://github.com/clerkinc/clerk-gatsby-starter',

  // Social
  facebook: 'https://www.facebook.com/clerkdev',
  twitter: 'https://twitter.com/ClerkDev',
  linkedin: 'https://www.linkedin.com/company/clerkinc',
  github: 'https://github.com/clerkinc',
  discord: 'https://discord.com/invite/b5rXHjAg7A',

  // Guides and Tutorials
  gatsbyBlog: '/blog/add-authentication-to-your-gatsby-app',
  firebaseTutorial: '/blog/build-a-premium-recipes-app-clerk-firebase',
  supabase: '/blog/nextjs-supabase-todos-with-multifactor-authentication',
  hasuraTutorial: '/tutorials/build-a-cookie-clicker-app-with-clerk-and-hasura',
  nextAuthGuide: '/guides/nextjs-authentication',
  fiveAuthContexts:
    '/guides/nextjs-authentication/five-authentication-contexts',
  serverlessAPIRoutes: '/guides/nextjs-authentication/serverless-api-routes',
  edgeMiddleware: '/guides/nextjs-authentication/edge-middleware',
  ssrPages: '/guides/nextjs-authentication/server-side-rendering-components',
  csrPages: '/guides/nextjs-authentication/client-side-rendering-components',
  ssgPages: '/guides/nextjs-authentication/static-generation-components',
  nextDifference:
    '/guides/nextjs-authentication/why-is-authentication-in-next-js-different',
  redwoodGuide: '/tutorials/redwoodjs-blog-tutorial-with-clerk',

  calendlyUrl: 'https://calendly.com/clerk-auth/intro-call'
} as const;

// Value refers to category overview page
// Paths used to render custom layout
export const DOCS_URLS = {
  home: '/docs',
  quickstarts: '/docs/quickstarts/overview',
  componentReference: '/docs/component-reference/overview',
  apiReference: '/docs/reference/overview',
  integrations: '/docs/integration/overview',
  deployments: '/docs/deployments/overview',
  security: '/docs/security/introduction',
  testing: '/docs/testing/overview',
  troubleshooting: '/docs/troubleshooting/overview',
  upgrading: '/docs/upgrade-guides/v3-introduction'
} as const;

// Value refers to URL category slug
export const DOCS_CATEGORIES = {
  home: 'home',
  quickstarts: 'quickstarts',
  nextjs: 'nextjs',
  authentication: 'authentication',
  requestAuthentication: 'request-authentication',
  users: 'users',
  organizations: 'organizations',
  componentCustomization: 'component-customization',
  componentReference: 'component-reference',
  apiReference: 'reference',
  integrations: 'integration',
  deployments: 'deployments',
  security: 'security',
  testing: 'testing',
  troubleshooting: 'troubleshooting',
  upgrading: 'upgrade-guides'
} as const;

export const SECTION_IDS = {
  homeHero: 'home-hero',
  homeIntegrations: 'home-integrations',
  homeClerkComponents: 'home-clerk-components',
  homeFeatures: 'home-features',
  homeTestimonials: 'home-testimonials',
  header: 'header',
  footer: 'footer',
  demo: 'demo',
  bottomCTA: 'bottom-cta',
  team: 'team',
  investors: 'investors'
} as const;

export const PURPLE_BG_PAGES = [
  '/features',
  '/components',
  '/blog',
  '/tutorials',
  '/render'
];

export const CODE_STRING = {
  NEXT_FRONTEND_STRING: 'NEXT_PUBLIC_CLERK_FRONTEND_API=',
  REACT_FRONTEND_STRING: 'REACT_APP_CLERK_FRONTEND_API=',
  GENERIC_FRONTEND_STRING: 'CLERK_FRONTEND_API=',
  CLERK_API_KEY_STRING: 'CLERK_API_KEY=',
  CLERK_JWT_KEY_STRING: 'CLERK_JWT_KEY=',
  GENERIC_PUBLISHABLE_STRING: 'CLERK_PUBLISHABLE_KEY=',
  NEXT_PUBLISHABLE_STRING: 'NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY=',
  REACT_PUBLISHABLE_STRING: 'REACT_APP_CLERK_PUBLISHABLE_KEY=',
  CLERK_SECRET_KEY_STRING: 'CLERK_SECRET_KEY='
};

export const EXAMPLE_PATH = 'cms-sanity';
export const CMS_NAME = 'Sanity';
export const CMS_URL = 'https://sanity.io/';
export const HOME_OG_IMAGE_URL =
  'https://og-image.vercel.app/Next.js%20Blog%20Example%20with%20**Sanity**.png?theme=light&md=1&fontSize=75px&images=https%3A%2F%2Fassets.vercel.com%2Fimage%2Fupload%2Ffront%2Fassets%2Fdesign%2Fnextjs-black-logo.svg&images=data%3Aimage%2Fsvg%2Bxml%3Bbase64%2CPHN2ZyB2aWV3Qm94PSIwIDAgMTA1IDIyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMWVtIj48dGl0bGU%2BU2FuaXR5PC90aXRsZT48cGF0aCBvcGFjaXR5PSIwLjciIGQ9Ik03OC4xNzkzIDcuOTkyNjFWMjEuMDAyOEg3My45MDMxVjEwLjIxMzhMNzguMTc5MyA3Ljk5MjYxWiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg%2BPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNMjAuOTUxMSAyMS4zM0wzMC45NDQgMTYuMTA1MUwyOS43MTIxIDEyLjkxNDFMMjMuMTMzMiAxNS45ODIxTDIwLjk1MTEgMjEuMzNaIiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48cGF0aCBvcGFjaXR5PSIwLjUiIGQ9Ik03My45MDMxIDEwLjIwMjdMODQuNzQ0MyA0LjY1NDc3TDgyLjkxMjYgMS41NTcxTDczLjkwMzEgNS45NTk5N1YxMC4yMDI3WiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg%2BPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNNDMuMzcwNSA2Ljk2MjMzVjIxLjAwMjhIMzkuMjkyN1YxLjAwNzE0TDQzLjM3MDUgNi45NjIzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciI%2BPC9wYXRoPjxwYXRoIG9wYWNpdHk9IjAuNSIgZD0iTTI3LjEyOTkgNi4xODYxN0wyMC45NTExIDIxLjMzTDE3Ljc3MzEgMTguNTk0M0wyNS4xMzUzIDEuMDA3MTRMMjcuMTI5OSA2LjE4NjE3WiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg%2BPHBhdGggZD0iTTI1LjEzNTMgMS4wMDcxNEgyOS4zNDc3TDM3LjEzODYgMjEuMDAyOEgzMi44MjY5TDI1LjEzNTMgMS4wMDcxNFoiIGZpbGw9ImN1cnJlbnRDb2xvciI%2BPC9wYXRoPjxwYXRoIGQ9Ik00NC4wMDEyIDEuMDA3MTRMNTIuOTgyNCAxNC42NjgyVjIxLjAwMjhMMzkuMjkyNyAxLjAwNzE0SDQ0LjAwMTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48cGF0aCBkPSJNNjQuOTE4MyAxLjAwNzE0SDYwLjY3MzlWMjEuMDA2M0g2NC45MTgzVjEuMDA3MTRaIiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48cGF0aCBkPSJNNzMuOTAzMSA0LjY1NDc0SDY3LjM3VjEuMDA3MTRIODIuNTg2N0w4NC43NDQzIDQuNjU0NzRINzguMTc5M0g3My45MDMxWiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg%2BPHBhdGggb3BhY2l0eT0iMC41IiBkPSJNOTcuMjc1NCAxMy40MTUzVjIxLjAwMjhIOTMuMDYyOVYxMy40MTUzIiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48cGF0aCBkPSJNOTMuMDYyOSAxMy40MTUyTDEwMC4xOTEgMS4wMDcxNEgxMDQuNjY2TDk3LjI3NTQgMTMuNDE1Mkg5My4wNjI5WiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg%2BPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNOTMuMDYzIDEzLjQxNTJMODUuNzM2MyAxLjAwNzE0SDkwLjM0NTZMOTUuMzA5MiA5LjUxMDA4TDkzLjA2MyAxMy40MTUyWiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg%2BPHBhdGggZD0iTTEuOTYxMjYgMy4zMTQ3OUMxLjk2MTI2IDYuMDk5MjEgMy43MTE0NSA3Ljc1NTk1IDcuMjE1MzYgOC42Mjk1NkwxMC45MjgzIDkuNDc1MzNDMTQuMjQ0NCAxMC4yMjM2IDE2LjI2MzkgMTIuMDgyMiAxNi4yNjM5IDE1LjExMDNDMTYuMjg5NyAxNi40Mjk1IDE1Ljg1MzEgMTcuNzE3MyAxNS4wMjc0IDE4Ljc1NzlDMTUuMDI3NCAxNS43MzY4IDEzLjQzNjcgMTQuMTA0NCA5LjU5OTcyIDEzLjEyMjlMNS45NTQwOSAxMi4zMDg1QzMuMDM0NzUgMTEuNjU0MSAwLjc4MTQ3OCAxMC4xMjYyIDAuNzgxNDc4IDYuODM3MDlDMC43NjYxMjMgNS41NjY5MyAxLjE4MTE2IDQuMzI3ODEgMS45NjEyNiAzLjMxNDc5IiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48cGF0aCBvcGFjaXR5PSIwLjciIGQ9Ik01Mi45ODI0IDEzLjY0MTVWMS4wMDcxNEg1Ny4wNjAyVjIxLjAwMjhINTIuOTgyNFYxMy42NDE1WiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg%2BPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNMTIuNzQ1OCAxNC4zNjg5QzE0LjMyOTQgMTUuMzY0MyAxNS4wMjM4IDE2Ljc1NjUgMTUuMDIzOCAxOC43NTQ0QzEzLjcxMyAyMC40MDQxIDExLjQxMDEgMjEuMzMgOC43MDMzMyAyMS4zM0M0LjE0NzE4IDIxLjMzIDAuOTU4NTc3IDE5LjEyNjggMC4yNSAxNS4yOTgySDQuNjI1NDdDNS4xODg3OCAxNy4wNTU5IDYuNjgwMzQgMTcuODcwMyA4LjY3MTQ0IDE3Ljg3MDNDMTEuMTAxOSAxNy44NzAzIDEyLjcxNzQgMTYuNTk2NCAxMi43NDkzIDE0LjM2MTkiIGZpbGw9ImN1cnJlbnRDb2xvciI%2BPC9wYXRoPjxwYXRoIG9wYWNpdHk9IjAuNyIgZD0iTTQuMjM1NjcgNy40NDI2N0MzLjUxMjUgNy4wMjA0NSAyLjkxOTIgNi40MTM3NSAyLjUxODczIDUuNjg2OTdDMi4xMTgyNyA0Ljk2MDE5IDEuOTI1NTggNC4xNDA0NSAxLjk2MTEzIDMuMzE0NzZDMy4yMjU5NCAxLjY3ODkxIDUuNDI2MDggMC42Nzk5OTMgOC4xMDgwNCAwLjY3OTk5M0MxMi43NDkyIDAuNjc5OTkzIDE1LjQzNDcgMy4wODg1MiAxNi4wOTcyIDYuNDc4NTZIMTEuODg4M0MxMS40MjQyIDUuMTQyMDMgMTAuMjYyMSA0LjEwMTM2IDguMTQzNDcgNC4xMDEzNkM1Ljg3OTU3IDQuMTAxMzYgNC4zMzQ4NyA1LjM5NjExIDQuMjQ2MjkgNy40NDI2NyIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg%2BPC9zdmc%2B&widths=undefined&widths=auto&heights=250&heights=150';
